import { render, staticRenderFns } from "./ModalMailDetail.vue?vue&type=template&id=445a1621"
import script from "./ModalMailDetail.vue?vue&type=script&lang=js"
export * from "./ModalMailDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports